module.exports = __webpack_public_path__ + "img/legal-and-general.70880e75.svg";